import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { settingsApi } from '../api';

export function useTeamMembers(spaceId) {
    return useQuery({
        queryKey: ['settings', 'team', spaceId],
        queryFn: () => settingsApi.fetchTeamMembers(spaceId),
        enabled: !!spaceId,
    });
}

export function useInviteTeamMember(spaceId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ email, name }) => settingsApi.inviteTeamMember(spaceId, { email, name }),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['settings', 'team', spaceId] }),
    });
}

export function useUpdateMemberRole(spaceId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ userId, role }) => settingsApi.updateMemberRole(spaceId, userId, role),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['settings', 'team', spaceId] }),
    });
}

export function useUpdateMemberPermissions(spaceId) {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: ({ userId, permissions }) => settingsApi.updateMemberPermissions(spaceId, userId, permissions),
        onSuccess: () => qc.invalidateQueries({ queryKey: ['settings', 'team', spaceId] }),
    });
}
